import React from "react";
//Limitless
import { useExpertTaskListContext } from "./expert-task-list/ExpertTaskListContext";
import { useExpertMessageContext } from "./expert-message/ExpertMessageContext";
import { useAuthenticationContext } from "./authentication/AuthenticationContext";
export const useExpertCleanUpHook = () => {
  const {
    clearTasklist
  } = useExpertTaskListContext();
  const {
    message,
    clearMessageAndUnclaim,
    clearMessage
  } = useExpertMessageContext();
  const {
    auth
  } = useAuthenticationContext();
  React.useEffect(() => {
    if (!auth.authenticated) {
      cleanUp();
    }
  }, [auth]);
  const cleanUp = () => {
    clearTasklist();
    //if there's a message, unclaim it
    if (message.inbox && message.inbox.claimed) {
      clearMessageAndUnclaim();
    } else {
      clearMessage();
    }
  };
  return {
    cleanUp
  };
};